/**
 *建設zenDesk.js
 */
module.exports = { 
    install : function buildZenDesk(options = {}) {
    const zenDeskKey = "582f3978-f877-421b-8455-b2817af2a5b6";
    const root = new Object();
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.asyne = true;
    script.id = "ze-snippet";
    script.src = "https://static.zdassets.com/ekr/snippet.js?key=582f3978-f877-421b-8455-b2817af2a5b6";
    
    const first = document.getElementsByTagName("div")[0];
    first.parentNode.insertBefore(script, first);

    window.zESettings = options.settings;
    let isLoaded = false;

    root.load = zendeskKey => {
           
      delete window.zE;
      const first = document.getElementsByTagName("script")[0];
      first.parentNode.insertBefore(script, first);

      script.onload = event => {
        isLoaded = true;

        if (options.hideOnLoad) {
          root.hide();
        }

        root.$emit("loaded", event);

        window.zE("webWidget:on", "open", () => {
          root.$emit("open");
        });

        window.zE("webWidget:on", "close", () => {
          root.$emit("close");
        });
      };
    };

    if (!options.disabled) {
      root.load(zenDeskKey);
    }

    root.hide = () => window.zE("webWidget", "hide");
    root.show = () => window.zE("webWidget", "show");
    root.logout = () => window.zE("webWidget", "logout");
    root.identify = user => window.zE("webWidget", "identify", user);
    root.prefill = user => window.zE("webWidget", "prefill", user);
    root.setLocale = locale => window.zE("webWidget", "setLocale", locale);
    root.updateSettings = settings => window.zE("webWidget", "updateSettings", settings);
    root.clear = () => window.zE("webWidget", "clear");
    root.updatePath = options => window.zE("updatePath", "clear", options);
    root.toggle = () => window.zE("webWidget", "toggle");
    root.reset = () => window.zE("webWidget", "reset");
    root.close = () => window.zE("webWidget", "close");
    root.open = () => window.zE("webWidget", "open");

    Object.defineProperty(root, "zE", {
      get: function get() {
        return window.zE;
      }
    });

    //Vue.prototype.$zendesk = root;    
    return root;
    }
}